module.exports = __webpack_public_path__ + "img/1.0388c07c.jpg";